import { create } from "zustand";
import { devtools } from "zustand/middleware";

import type { CompetitorValueMap } from "../types";

interface ICompetitorsFilterState {
    selectedCompetitors: CompetitorValueMap;
    selectedCompetitorIds: string[];
}

interface ICompetitorsFilterStore extends ICompetitorsFilterState {
    reset: () => void;
    setSelectedCompetitors: (competitors: CompetitorValueMap) => void;
}

const initialState: ICompetitorsFilterState = {
    selectedCompetitors: new Map(),
    selectedCompetitorIds: [],
};

export const useCompetitorsFilterStore = create<ICompetitorsFilterStore>()(
    devtools(
        (set) => ({
            ...initialState,
            reset: () => set(initialState),
            setSelectedCompetitors: (competitors) =>
                set({
                    selectedCompetitors: competitors,
                    selectedCompetitorIds: Array.from(competitors.keys()),
                }),
        }),
        { name: "CompetitorsFilterStore" },
    ),
);
